const DEFAULT_INTEREST_OPTIONS = [
    { slug: 'training_certifications', name: 'Capacitação e certificações' },
    { slug: 'training_ndm_accessories', name: 'Notebooks, Desktops, Monitores e Acessórios - Capacitação e certificações' },
    { slug: 'training_servers', name: 'Servidores - Capacitação e certificações' },
    { slug: 'training_storage', name: 'Storage - Capacitação e certificações' },
    { slug: 'training_ai', name: 'IA - Capacitação e certificações' },
    { slug: 'training_backup', name: 'Soluções de Backup - Capacitação e certificações' },
    { slug: 'training_cybersecurity', name: 'Cybersegurança - Capacitação e certificações' },
    { slug: 'training_software', name: 'Softwares - Capacitação e certificações' },
    { slug: 'campaigns_awards', name: 'Campanhas e premiações' },
    { slug: 'performance_tips', name: 'Mercado de Tecnologia' },
    { slug: 'program_news', name: 'Novidades do programa' },
    { slug: 'launches', name: 'Lançamentos' },
];

new Vue({
    el: "#profile",
    data: {
        model: {},
        profile: {},
        editMode: 0,
        message: '',
        interestOptions: [...DEFAULT_INTEREST_OPTIONS],
        profileImgToUpload: {
            target: false,
            file: false,
            change: false,
        },
        photoTaken: false,
        mediaStream: '',
        videoBox: {},
        photoCountdown: 5,
        showCountdown: false,
        avatarModal: {},
        overlay: {},
        takePicture: false,
        avatarLoaded: false,
        avatarUploadInitialized: false,
        showAvatarGallery: false,
        selectedIllustration: null,
        originalIllustration: null,
        savingIllustration: false,
        avatarOrder: [1, 2, 3, 5, 6, 10, 12, 4, 7, 8, 9, 11, 13, 14],
        reguaPreferences: {
            show_in_certified_highlight: true,
            receive_promotional_emails: true,
            receive_essential_emails: true,
        },
        reguaPreferencesLoaded: false,
        vitrineEligible: false,
    },
    computed: {
        selectedInterestLabels() {
            const ids = (Array.isArray(this.model.interest_ids) ? this.model.interest_ids : [])
                .map((id) => Number(id));
            return this.interestOptions
                .filter((option) => ids.includes(Number(option.id)))
                .map((option) => option.name || option.label);
        },
        isEliteConsultant() {
            return this.model && (this.model.groupID == 3 || this.model.group_id == 3) && this.vitrineEligible;
        },
        userInitials() {
            var name = (this.model && this.model.name) || '';
            var parts = name.trim().split(/\s+/);
            var first = parts[0] || '';
            var last = parts.length > 1 ? parts[parts.length - 1] : '';
            return (first.charAt(0) + last.charAt(0)).toUpperCase();
        },
        notificationEmailDisplay() {
            return this.model.notification_email || this.model.email || '—';
        },
        isrDisplay() {
            const { badge, name } = this.resolveIsr();
            if (badge && name) {
                return `${badge} - ${name}`;
            }
            if (badge) {
                return badge;
            }
            if (name) {
                return name;
            }
            return '—';
        },
        lastAccessDisplay() {
            return this.model.last_access_at
                || this.model.last_access
                || this.model.updateDate
                || null;
        },
        accessFrequencyLevel() {
            const lastAccess = this.lastAccessDisplay;
            if (!lastAccess) {
                return 'unknown';
            }
            const days = this.daysSince(lastAccess);
            if (days <= 7) {
                return 'high';
            }
            if (days <= 30) {
                return 'medium';
            }
            return 'low';
        },
        accessFrequencyLabel() {
            if (this.model.access_frequency) {
                return this.model.access_frequency;
            }
            const labels = {
                high: 'Alta',
                medium: 'Média',
                low: 'Baixa',
                unknown: '—',
            };
            return labels[this.accessFrequencyLevel] || '—';
        },
    },
    created: async function () {
        if (typeof window.recordLastAccess === 'function') {
            await window.recordLastAccess(true);
        }
        await this.get();
        this.loadAvatarIllustration();
    },
    mounted: async function () {
        const { search } = window.location;
        const params = new URLSearchParams(search);

        if (params.get('editMode')) {
            document.addEventListener('DOMContentLoaded', () => {
                this.openModalTakePicOrUpload();
            });
        }

        this.videoBox = document.getElementById('avatar-video');
        this.canvasSnapShot = document.getElementById('canvas');
        this.avatarModal = document.getElementById('avatar-modal');
    },
    methods: {
        async get() {
            const response = await $getUser;
            this.model = await this.loadUserModel(response.data);
            this.profile = { ...this.model };
            this.getReguaPreferences();
        },
        async getReguaPreferences() {
            try {
                const { data } = await axios.get(api_url + 'account/preferences', {
                    headers: { Authorization: 'Bearer ' + localStorage.token },
                });
                this.reguaPreferences = {
                    show_in_certified_highlight: data.show_in_certified_highlight ?? true,
                    receive_promotional_emails: data.receive_promotional_emails ?? true,
                    receive_essential_emails: data.receive_essential_emails ?? true,
                };
                this.reguaPreferencesLoaded = true;
            } catch (e) {
                this.reguaPreferencesLoaded = false;
            }
            if (this.model && (this.model.groupID == 3 || this.model.group_id == 3)) {
                try {
                    const { data } = await axios.get('/vitrine-consent/check', {
                        params: { user_id: localStorage.getItem('user_id') },
                        headers: $headerAuth,
                    });
                    this.vitrineEligible = !!(data && data.eligible);
                    if (data && typeof data.current_consent !== 'undefined') {
                        this.reguaPreferences.show_in_certified_highlight = !!data.current_consent;
                    }
                } catch (e) {}
            }
        },
        async saveReguaPreferences() {
            try {
                await axios.put(api_url + 'account/preferences', {
                    show_in_certified_highlight: this.reguaPreferences.show_in_certified_highlight,
                    receive_promotional_emails: this.reguaPreferences.receive_promotional_emails,
                    receive_essential_emails: this.reguaPreferences.receive_essential_emails,
                }, {
                    headers: { Authorization: 'Bearer ' + localStorage.token },
                });
            } catch (e) {
                // Silencioso: o PUT do user já salvou; preferências podem falhar se o proxy não existir.
            }
        },
        async loadUserModel(data) {
            const previousIsr = this.resolveIsrFromModel(this.model || {});
            let model = this.normalizeUserModel(data);
            model = await this.enrichIsrFromAccount(model);

            const currentIsr = this.resolveIsrFromModel(model);
            if (!currentIsr.name && previousIsr.name) {
                model = {
                    ...model,
                    badge: model.badge || previousIsr.badge,
                    consultants: {
                        ...(model.consultants || {}),
                        name: previousIsr.name,
                        badge: previousIsr.badge,
                    },
                };
            }

            return model;
        },
        resolveNotificationEmail(model) {
            const primary = model.email || '';
            const secondary = model.email2 || '';
            let selected = model.notification_email || '';

            if (!selected && model.notification_email_source) {
                selected = model.notification_email_source === 'email2' && secondary
                    ? secondary
                    : primary;
            }

            const allowed = [primary, secondary].filter(Boolean);
            if (!selected || !allowed.includes(selected)) {
                return primary;
            }

            return selected;
        },
        normalizeUserModel(data) {
            const model = { ...data };
            model.interest_ids = this.parseInterestIds(model);
            model.notification_email = this.resolveNotificationEmail(model);
            if (model.birth_date && model.birth_date.indexOf('T') !== -1) {
                model.birth_date = model.birth_date.split('T')[0];
            }
            this.interestOptions = this.resolveInterestOptions(model);
            return model;
        },
        resolveInterestOptions(model) {
            const fromApi = model.available_interests || model.interest_options;
            if (Array.isArray(fromApi) && fromApi.length) {
                return fromApi.map((item) => ({
                    id: Number(item.id),
                    slug: item.slug,
                    name: item.name || item.label,
                }));
            }
            return [...DEFAULT_INTEREST_OPTIONS];
        },
        parseInterestIds(model) {
            if (Array.isArray(model.interest_ids)) {
                return model.interest_ids.map((id) => Number(id)).filter((id) => id > 0);
            }

            const interests = model.interests;
            if (!interests) {
                return [];
            }

            if (Array.isArray(interests)) {
                if (interests.length && typeof interests[0] === 'object') {
                    return interests
                        .map((item) => Number(item.id))
                        .filter((id) => id > 0);
                }

                return interests
                    .map((value) => {
                        const asNumber = Number(value);
                        if (asNumber > 0 && String(asNumber) === String(value)) {
                            return asNumber;
                        }
                        const match = DEFAULT_INTEREST_OPTIONS.find((option) => option.slug === value);
                        return match ? match.id : null;
                    })
                    .filter((id) => id);
            }

            if (typeof interests === 'string') {
                try {
                    const parsed = JSON.parse(interests);
                    return this.parseInterestIds({ interests: parsed });
                } catch (e) {
                    return [];
                }
            }

            return [];
        },
        resolveIsr() {
            return this.resolveIsrFromModel(this.model || {});
        },
        async enrichIsrFromAccount(model) {
            const { name } = this.resolveIsrFromModel(model);
            if (name || !window.$getAccount) {
                return model;
            }

            try {
                const account = await window.$getAccount;
                const accountIsr = account?.consultants;
                if (!accountIsr?.name) {
                    return model;
                }

                return {
                    ...model,
                    badge: model.badge || accountIsr.badge,
                    consultants: {
                        ...(model.consultants || {}),
                        ...accountIsr,
                    },
                };
            } catch (e) {
                return model;
            }
        },
        resolveIsrFromModel(model) {
            const isr = model.consultants || model.consultant || model.isr || null;
            const badge = model.badge || isr?.badge || model.isr_badge || null;
            const name = (typeof isr === 'string' ? isr : null)
                || isr?.name
                || model.isr_name
                || model.consultant_name
                || model.consultantName
                || null;
            return { badge, name };
        },
        async post() {
            const self = this;
            const form = self.buildEditablePayload();
            if (self.profileImgToUpload.change) {
                await self.uploadAvatar();
            }
            await axios
                .put(
                    api_url + "user/" + localStorage.getItem("user_id"),
                    form,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then(async function (response) {
                    if (self.isEliteConsultant) {
                        try {
                            var showInHighlight = self.reguaPreferences.show_in_certified_highlight ? 1 : 0;
                            await axios.post('/vitrine-consent', {
                                user_id: localStorage.getItem('user_id'),
                                vitrine_consent: showInHighlight,
                            }, {
                                headers: Object.assign({ 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') || '' }, $headerAuth || {}),
                            });
                        } catch (e) {}
                    }
                    if (self.isEliteConsultant && self.selectedIllustration !== self.originalIllustration) {
                        await self.persistAvatarIllustration();
                    }
                    self.model = await self.loadUserModel(response.data);
                    self.profile = { ...self.model };
                    self.saveReguaPreferences();
                    self.editMode = 0;
                    self.showAvatarGallery = false;
                    $.toast({
                        text: "Dados atualizados com sucesso!",
                        position: 'bottom-right',
                        textColor: 'white',
                        bgColor: '#6EA204',
                    });
                    setTimeout(function () { self.message = ''; }, 3000);
                    self.profileImgToUpload.change = false;
                })
                .catch(function () {
                    $.toast({
                        text: "Erro ao salvar dados",
                        position: 'bottom-right',
                        textColor: 'white',
                        bgColor: '#CE1126',
                    });
                    setTimeout(function () { self.message = ''; }, 3000);
                });
        },
        buildEditablePayload() {
            return {
                summary: this.model.summary || '',
                birth_date: this.model.birth_date || null,
                notification_email: this.model.notification_email || this.model.email || '',
                interest_ids: (this.model.interest_ids || []).map((id) => Number(id)),
            };
        },
        formatDate(value) {
            if (!value) {
                return '—';
            }
            const dateOnly = String(value).split(/[T\s]/)[0];
            const isoParts = dateOnly.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (isoParts) {
                return `${isoParts[3]}/${isoParts[2]}/${isoParts[1]}`;
            }
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return value;
            }
            return date.toLocaleDateString('pt-BR');
        },
        formatDateTime(value) {
            if (!value) {
                return '—';
            }
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return this.formatDate(value);
            }
            return date.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
        daysSince(value) {
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return 999;
            }
            const diff = Date.now() - date.getTime();
            return Math.floor(diff / (1000 * 60 * 60 * 24));
        },
        sendAvatar(e) {
            var self = this;
            const file = e.target.files[0];
            var reader = new FileReader();
            if (e.target.files && e.target.files[0]) {
                self.profileImgToUpload = { target: e.target.result, file, change: true };
                reader.onload = function (ev) {
                    $(".imagePreview").css(
                        "background-image",
                        "url(" + ev.target.result + ")"
                    );
                    $(".imagePreview").hide();
                    $(".imagePreview").fadeIn(650);
                };
                reader.readAsDataURL(e.target.files[0]);
                this.avatarLoaded = true;
            }
        },
        async uploadAvatar() {
            const form = new FormData();
            form.append("avatar", this.profileImgToUpload.file);
            await axios.post(
                api_url +
                "user/image/" +
                localStorage.getItem("user_id"),
                form,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
        },
        toggleEdit() {
            this.editMode = 1;
        },
        openModalTakePicOrUpload() {
            this.addOverlay();
            this.avatarModal.style.display = "block";
        },
        addOverlay() {
            let overlay = document.createElement('div');

            this.overlay = overlay;
            this.overlay.style.position = 'fixed';
            this.overlay.style.top = '0';
            this.overlay.style.left = '0';
            this.overlay.style.width = '100%';
            this.overlay.style.height = '100%';
            this.overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            this.overlay.style.zIndex = '9998';
            this.overlay.setAttribute("id", "overlay");

            document.body.appendChild(this.overlay);
        },
        removeOverlay() {
            this.overlay.remove();
        },
        startCameraStream() {
            this.videoBox.style.display = 'block';

            navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                    this.videoBox.srcObject = stream;
                    this.mediaStream = stream;
                })
                .catch((err) => {
                    console.error("Error accessing camera: " + err);
                });
        },
        stopCameraStream() {
            if (this.mediaStream != '') {
                this.mediaStream.getTracks().forEach(track => track.stop());
                this.videoBox.srcObject = null;
                this.mediaStream = '';
            }
        },
        startPhotoCountdown() {
            if (!this.showCountdown) {
                this.showCountdown = true;

                const photoCountdownInterval = setInterval(() => {
                    this.photoCountdown--;
                    if (this.photoCountdown === 0) {
                        clearInterval(photoCountdownInterval);
                        this.photoCountdown = 5;
                        this.capturePhoto();
                        this.showCountdown = false;
                    }
                }, 1000);
            }
        },
        capturePhoto() {
            setTimeout(() => {
                this.canvasSnapShot.style.opacity = 0;
                this.photoTaken = true;
                this.canvasSnapShot.width = this.videoBox.videoWidth;
                this.canvasSnapShot.height = this.videoBox.videoHeight;
                this.canvasSnapShot.getContext('2d').drawImage(this.videoBox, 0, 0, this.videoBox.videoWidth, this.videoBox.videoHeight);
            }, 200);

            setTimeout(() => {
                this.canvasSnapShot.style.opacity = 1;
            }, 400);
        },
        resetPhotoState() {
            this.avatarModal.style.display = "none";
            this.stopCameraStream();
            this.photoTaken = false;
            this.removeOverlay();
            this.takePicture = false;
            this.avatarLoaded = false;
            this.avatarUploadInitialized = false;
            this.showAvatarGallery = false;
            this.selectedIllustration = this.originalIllustration;
            this.savingIllustration = false;
        },
        showAvatarUploadMessage() {
            $.toast({
                text: "Avatar atualizado com sucesso!",
                position: 'bottom-right',
                textColor: 'white',
                bgColor: '#6EA204',
            });
            setTimeout(function () { this.message = ''; }, 4000);
        },
        uploadPhoto() {
            if (!this.avatarUploadInitialized) {
                this.avatarUploadInitialized = true;
                this.canvasSnapShot.toBlob((blob) => {
                    const formData = new FormData();
                    const avatarUrl = URL.createObjectURL(blob);

                    formData.append('avatar', blob);

                    $(".imagePreview").each(function () {
                        $(this).css(
                            "background-image",
                            `url(${avatarUrl})`,
                        ).hide().fadeIn(650);
                    });

                    fetch(api_url + "user/image/" + localStorage.getItem("user_id"), {
                        method: 'POST',
                        body: formData,
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    })
                        .then(() => {
                            this.resetPhotoState();
                            this.showAvatarUploadMessage();
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                }, 'image/png');
            }
        },
        finishLoadAvatar() {
            this.resetPhotoState();
            this.post();
        },
        async loadAvatarIllustration() {
            try {
                var userId = localStorage.getItem('user_id');
                if (!userId) return;
                var { data } = await axios.get('/vitrine-avatar', { params: { user_id: userId }, headers: $headerAuth });
                if (data && data.avatar_illustration) {
                    this.selectedIllustration = data.avatar_illustration;
                    this.originalIllustration = data.avatar_illustration;
                } else {
                    this.selectedIllustration = 0;
                    this.originalIllustration = 0;
                }
            } catch (e) {}
        },
        selectIllustration(n) {
            this.selectedIllustration = n;
        },
        async persistAvatarIllustration() {
            var userId = localStorage.getItem('user_id');
            if (!userId) return;
            var csrfToken = $('meta[name="csrf-token"]').attr('content') || '';
            try {
                var authHeaders = Object.assign({ 'X-CSRF-TOKEN': csrfToken }, $headerAuth || {});
                if (this.selectedIllustration) {
                    await axios.post('/vitrine-avatar', {
                        user_id: userId,
                        avatar_illustration: this.selectedIllustration,
                    }, { headers: authHeaders });
                } else {
                    await axios.post('/vitrine-avatar/remove', {
                        user_id: userId,
                    }, { headers: authHeaders });
                }
                this.originalIllustration = this.selectedIllustration;
            } catch (e) {}
        },
        changePassword() {
            const domain = window.location.origin;
            const profileUrl = `${domain}/perfil/trocar-senha`;
            window.location.href = profileUrl;
        },
    },
});
